import React from 'react';
import { motion } from 'framer-motion';
import './Fisioterapia.css';

export default function Fisioterapia() {
  const opcionesTerap = [
    "Terapia manual",
    "Ecografía músculo-esquelética",
    "Electroterapia",
    "Fisioterapia invasiva (electrólisis, neuromodulación, punción seca)",
    "Vendaje funcional",
    "Ejercicio terapéutico"
  ];

  const precios = [

    { descripcion: "Consulta individual", precio: "50 €" },
  ];

  return (
    <div className="fisioterapia-container">
      <motion.h1 
        className="fisioterapia-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        FISIOTERAPIA
      </motion.h1>

      <motion.div 
        className="fisioterapia-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        <h2>Descripción:</h2>
        <p>
          Sesiones individuales para tratar el dolor y otras alteraciones funcionales con medios físicos.
        </p>
      </motion.div>

      <motion.div 
        className="fisioterapia-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <h2>Opciones terapéuticas:</h2>
        <ul className="fisioterapia-list">
          {opcionesTerap.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </motion.div>

      <motion.div 
        className="fisioterapia-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        <h2>Precios por sesión:</h2>
        <div className="fisioterapia-precios">
          {precios.map((item, index) => (
            <div key={index} className="fisioterapia-precio-cell">
              <p className="fisioterapia-precio">{item.precio}</p>
              <p className="fisioterapia-descripcion">{item.descripcion}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
